import { createFileRoute } from '@tanstack/react-router'
import { AdminSnippets } from '../features/admin'
import { adminSnippetsQuery } from '../features/admin/queries'
import { adminRouteState } from '../features/admin/route-state'

export const Route = createFileRoute('/admin/snippets')({
  ...adminRouteState,
  loader: ({ context }) => context.queryClient.ensureQueryData(adminSnippetsQuery()),
  component: AdminSnippets,
})
